import { CommentsEntityType } from 'api/comments';
import { MessageAccessType } from 'app-constants/enums/message';
import { dynamicManager } from 'pages/FormProcess/DynamicForm/DynamicManager';

export const prepareNewCommentPayload = ({ participants, ...payload }) => {
  const newFormCommentPayload = {
    EntityId: dynamicManager.getFormProcessId(),
    ParticipantIds: participants,
    FirstComment: {
      Text: payload.comment,
      CommentMeta: {
        Tags: payload.tag,
      },
      AccessType: payload.accessType || MessageAccessType.Everybody,
    },
    EntityType: CommentsEntityType.formComment,
    Meta: {
      ...payload.meta,
    },
  };

  return newFormCommentPayload;
};

export const prepareExistingCommentPayload = (payload) => {
  return {
    Text: payload.comment,
    AccessType: payload.accessType || MessageAccessType.Everybody,
    CommentMeta: {
      Tags: payload.tag || [],
    },
  };
};
